module.exports = __webpack_public_path__ + "img/trailhead_logo_old.97885701.png";